var $ = window.jQuery;

$('button.question').click(function() {
	if($(this).attr('aria-expanded') == 'false') {
		$(this).attr('aria-expanded', true)
	} else {
		$(this).attr('aria-expanded', false)
	}
})